import React, { useEffect, useState } from 'react'
import AnimatedLetters from "../AnimatedLetters/AnimatedLetters"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAws, faGitAlt, faNodeJs, faPython, faReact } from '@fortawesome/free-brands-svg-icons'
import { faDatabase } from '@fortawesome/free-solid-svg-icons'
import Loader from 'react-loaders'
import './about.scss'
import { Link } from 'react-router-dom'

const About = () => {
    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
        setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 3000)
    }, [])

    return (
        <>
            <div className="container about-page">
                <div className="text-zone">
                    <h1>
                        <AnimatedLetters letterClass={letterClass} strArray={["A", "b", "o", "u", "t", " ", "m", "e"]} idx={15} />
                    </h1>
                    <p>
                        I'm very ambitious Full-Stack Developer looking for a role in established IT company with the opportunity to work with the lastest
                        technologies on challenging and diverse projects.
                    </p>
                    <p align="LEFT">
                        I'm quietly confident, neturally curious and perpetually working on improving my chops a problem at a time.
                    </p>
                    <p>
                        If I need to defign myself in one sentence that would be a person who knows to fun, a gamer, and tech-obsessed!!!
                    </p>
                    <br />
                    <br />
                    <div className="cv-buttons">
                        <a className='flat-button' href="Erdinç Atay - Curriculum Vitae.pdf" target='_blank' >CV - English</a>
                        <a className='flat-button' href="Erdinç Atay - Öz Geçmiş.pdf" target='_blank'>CV - Türkçe</a>
                    </div>
                </div>

                <div className="stage-cube-cont">
                    <div className="cubespinner">
                        <div className="face1">
                            <FontAwesomeIcon icon={faNodeJs} color='#68a063' />
                        </div>
                        <div className="face2">
                            <FontAwesomeIcon icon={faReact} color='#5ED4F4' />
                        </div>
                        <div className="face3">
                            <FontAwesomeIcon icon={faPython} color='#4B8BBE' />
                        </div>
                        <div className="face4">
                            <FontAwesomeIcon icon={faAws} color='#FF9900' />
                        </div>
                        <div className="face5">
                            <FontAwesomeIcon icon={faGitAlt} color='#EC4D28' />
                        </div>
                        <div className="face6">
                            <FontAwesomeIcon icon={faDatabase} color='#DD0031' />
                        </div>
                    </div>
                </div>
            </div>
            <Loader type="pacman" />
        </>
    )
}

export default About
